export default {
  consent: {
    text: 'Prohlašuji, že jsem se seznámil/a s',
    link: 'informacemi o zpracování a ochraně osobních údajů',
  },
  rangeSlider: {
  },
};
